import { useEffect, useState } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import PropTypes from 'prop-types';
import { closeHeaderBannerAction, setHeaderBannerAction } from '../actions/checkoutUIActions';
import styles from './styles/CheckoutHeaderBanner.scss';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { connect } from 'react-redux';
import { BANNER_TYPES, PANES } from '../constants/checkoutConstants';
import { getCheckoutParam } from '../helpers/checkoutRedirects';
import banners from '../shared/banners';
import get from 'lodash.get';

const CheckoutHeaderBanner = ({
    banner,
    onCloseCheckoutBanner,
    openHeaderBanner,
    currentPane,
    isSetUp,
    viewer,
}) => {
    const { label, content, type } = banner || {};
    //TODO extract out these hooks into the banners file to keep this component more generic
    const [hasOpenedNextStep, setHasOpenedNextStep] = useState(false);
    const hasEmailOnlyMakeOffer = getCheckoutParam('emailOnlyMakeOffer');
    useEffect(() => {
        // display next step banner for email only users
        if (
            !get(viewer, 'disableEmailOnlyMakeOffer') &&
            hasEmailOnlyMakeOffer &&
            isSetUp &&
            currentPane === PANES.PANE_SHIPPING &&
            !hasOpenedNextStep
        ) {
            openHeaderBanner({
                banner: banners[BANNER_TYPES.NEXT_STEPS],
            });
            setHasOpenedNextStep(true);
        }
    }, [isSetUp, openHeaderBanner, currentPane, viewer, hasOpenedNextStep, hasEmailOnlyMakeOffer]);
    useEffect(() => {
        // next step banner should close if user moves passed shipping step
        if (type === BANNER_TYPES.NEXT_STEPS && currentPane !== PANES.PANE_SHIPPING && isSetUp) {
            onCloseCheckoutBanner();
        }
    }, [type, currentPane, isSetUp, onCloseCheckoutBanner]);
    return (
        banner && (
            <div className={styles.wrapper}>
                <div className={`${styles.contentFormatting} primary-page-width`}>
                    <div>
                        <div className={styles.label}>{label}</div>
                        <div className={styles.content}>{content}</div>
                    </div>
                    <div className={styles.close}>
                        <ModalCloseButton onClick={onCloseCheckoutBanner} />
                    </div>
                </div>
            </div>
        )
    );
};

CheckoutHeaderBanner.propTypes = {
    banner: PropTypes.shape({
        label: PropTypes.node,
        content: PropTypes.node,
        type: PropTypes.string,
    }),
    currentPane: PropTypes.string.isRequired,
    isSetUp: PropTypes.bool,
    onCloseCheckoutBanner: PropTypes.func.isRequired,
    openHeaderBanner: PropTypes.func.isRequired,
    viewer: PropTypes.object,
};

const ConnectedCheckoutHeaderBanner = connect(
    ({ pane, ui }) => ({ currentPane: pane.currentPane, isSetUp: pane.isSetUp, banner: ui.banner }),
    { onCloseCheckoutBanner: closeHeaderBannerAction, openHeaderBanner: setHeaderBannerAction }
)(CheckoutHeaderBanner);

export default createFragmentContainer(ConnectedCheckoutHeaderBanner, {
    viewer: graphql`
        fragment CheckoutHeaderBanner_viewer on Viewer {
            disableEmailOnlyMakeOffer: isEnabled(key: "disableEmailOnlyMakeOffer")
        }
    `,
});
